import { ApiRoutes } from "../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../base";
import { MaintenanceRequestBody, MaintenanceResponse } from "./types";

export class MaintenanceJson extends BaseAPI<
  MaintenanceRequestBody,
  MaintenanceResponse
> {
  protected route = ApiRoutes.maintenance;
  protected method = RequestMethod.GET;
}
